import { render, staticRenderFns } from "./huisbezoek.vue?vue&type=template&id=0ada2a74&"
import script from "./huisbezoek.vue?vue&type=script&lang=js&"
export * from "./huisbezoek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports